export default __webpack_public_path__ + "static/desk-img-ba949b50ff694ba5035e8b6f26086860.png";